export default __webpack_public_path__ + "ca372514feb02cf3d906f4c8758d5468.png";